module.exports = __webpack_public_path__ + "media/images/pages/peel/oxygen-c5763188b396e73ca863564259ba4fda.svg";